<div class="text-center">
    <h3 class="package-title">{{subscripitioncard.skuType}}</h3>
    <p class="package-price"><span class='price-symbol'>$</span>{{subscripitioncard.basicPrice| number :'1.2-3' }}</p>
    <p *ngIf="!subscripitioncard.isSingleQuantity" class="per-month">per month per license</p>
	<p *ngIf="subscripitioncard.isSingleQuantity" class="per-month">per month</p>
</div>
 
<div class="text-center box-section" [innerHTML]="subscripitioncard.moduleCount"></div>
<div class="package-description bullet-list" [innerHTML]="subscripitioncard.description">
</div>
<footer *hasPermission="shopPermission">
    <!--<a href="javascript:void(0)"  class="btn btn-secondary learnMoreTest btn-change" (click)="shopNow(subscripitioncard.id)" routerLinkActive="active" aria-label="Shop now.">Shop now</a>-->
    <a href="javascript:void(0)" class="btn btn-secondary learnMoreTest btn-change" *ngIf="subscripitioncard.detailFlag=='SHOPNOW'"
        (click)="shopNow(subscripitioncard.id)" routerLinkActive="active" role="button" attr.aria-label="Shop for {{subscripitioncard.productName}}">Shop now</a>
    <a href="javascript:void(0)" class="btn btn-secondary learnMoreTest btn-change" *ngIf="subscripitioncard.detailFlag=='ADDLICENSE'"
        (click)="shopNow('/manage')" routerLinkActive="active"  role="button" attr.aria-label="Manage {{subscripitioncard.productName}}">Manage product</a>
</footer>